import React from "react";
import { formatDisplayDate } from "utils/dateFormat";
import invoiceBg from "../../../assets/img/invoiceBackground.jpg";
import { useInvoicePrintTheme } from "hooks/useInvoicePrintTheme";
import { getInvoicePrintRootClassName } from "utils/invoicePrintTheme";

const PurchaseOrderTemplate = ({ printData, contentRef, darkPrint: darkPrintProp }) => {
  const { darkPrint: darkPrintHook } = useInvoicePrintTheme();
  const darkPrint = darkPrintProp ?? darkPrintHook;
  const getIncludedGSTPrice = () => {
    const total = printData?.invoices
      ?.filter((item) => item?.gst === "yes" || item?.gst === "true" || item?.gst === true)
      ?.reduce((sum, item) => sum + Number(item?.total) * 0.1, 0);
    return Number(total).toFixed(2);
  };

  const getSubTotal = () => {
    return printData?.invoices?.reduce(
      (sum, item) => sum + Number(item?.quantity) * Number(item?.price),
      0
    );
  };

  const getPurchaseOrderNumber = () => {
    if (printData?.companyName) {
      if (printData?.companyName?.includes("KOTHAR GROUP")) {
        return "KES-PO-" + printData?.invoiceId;
      }
      if (printData?.companyName?.includes("KOTHAR TECH")) {
        return "KS-PO-" + printData?.invoiceId;
      }
      if (printData?.companyName?.includes("CAM YOUTH")) {
        return "CYA-PO-" + printData?.invoiceId;
      } else {
        return "KES-PO-" + printData?.invoiceId;
      }
    } else {
      return "KES-PO-" + printData?.invoiceId;
    }
  };

  return (
    <div
      className={`printContent ${getInvoicePrintRootClassName(darkPrint)}`}
      ref={contentRef}
      style={{
        // backgroundImage: `url(${invoiceBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        WebkitPrintColorAdjust: "exact",
        printColorAdjust: "exact",
      }}
    >
      <div className="purchase-order-box">
        <div className="flex flex-col justify-between h-full">
          <div>
            <div className="invoice-header">
              <div
                className="invoice-heading"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <div className="invoice-title" style={{ fontSize: "28px", fontWeight: "bold" }}>
                  PURCHASE ORDER
                </div>
                <div>
                  <img
                    src={process.env.PUBLIC_URL + "/logo.png"}
                    alt="Kothar Logo"
                    style={{
                      height: "60px",
                      width: "auto",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
              </div>
              <div className="top-section" style={{ marginTop: "20px" }}>
                {/* Seller Information (Left) */}
                <div className="kothar-info">
                  <p className="font-semibold">Kothar Educational Services</p>
                  <p>273/398 Pitt Street, SYDNEY NSW 2000, AUSTRALIA</p>
                  {/* <p>ABN: 21650886301</p> */}
                </div>

                {/* Purchase Order Details (Middle) */}
                <div className="invoice-detail">
                  <div className="font-semibold">Purchase Order Date</div>
                  <div>{formatDisplayDate(printData?.issueDate || new Date())}</div>

                  <div className="font-semibold">Delivery Date</div>
                  <div>{formatDisplayDate(new Date())}</div>

                  <div className="font-semibold">Purchase Order Number</div>
                  <div>{getPurchaseOrderNumber()}</div>

                  {/* <div className="font-semibold">Reference</div>
                  <div>{reference}</div> */}

                  {/* <div className="font-semibold">Buyer ABN</div>
                  <div>{buyerABN}</div> */}
                </div>

                {/* Buyer Information (Right) */}
                <div className="client-info">
                  <div className="font-semibold">{printData?.invoiceTo}</div>
                  <div>{printData?.address}</div>
                </div>
              </div>
            </div>

            <table>
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>GST</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {printData?.invoices?.map((item, key) => (
                  <tr key={key}>
                    <td>{item?.description}</td>
                    <td>{item?.quantity}</td>
                    <td>{Number(item?.price ?? 0).toFixed(2)}</td>
                    <td>
                      {item?.gst === "yes" || item?.gst === "true" || item?.gst === true
                        ? "10%"
                        : "-"}
                    </td>
                    <td>{item?.total ?? Number(item?.price) * Number(item?.quantity)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="sub-total">
              <p>
                Subtotal: &nbsp;&nbsp;&nbsp;&nbsp;
                <span>
                  {printData?.subTotal ? Number(printData?.subTotal).toFixed(2) : getSubTotal()}
                </span>
              </p>
              <p>
                Total GST 10%: &nbsp;&nbsp;&nbsp;&nbsp;
                <span>{getIncludedGSTPrice()}</span>
              </p>
            </div>
            <div className=""></div>
            <p className="total">
              Total AUD: &nbsp;&nbsp;&nbsp;&nbsp;
              {(Number(printData?.subTotal) + Number(getIncludedGSTPrice()) ?? 0)?.toFixed(2)}
            </p>
          </div>
          <div className="payment-advice mb-24">
            <h2 className="font-bold">Delivery Details</h2>
            <div className="payment-advice-body">
              <div className="payment-advice-to">
                <div className="kothar-info">
                  <p>Suite 273, Level 2, 398/408 Pitt St Haymarket NSW 2000, Australia</p>
                  <p>Contact Number: +61 480 322 403</p>
                  <p>Extra Instructions: {printData?.comments}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderTemplate;
